import { DataConnectionType } from '../api/api-campaigns.service.generated';

export const dataConnectionTypes = [
  {
    value: DataConnectionType.Salesforce,
    name: DataConnectionType.Salesforce,
  },
];

export const connectionTemplateOptions = [
  {
    name: 'Switzerland',
    value: 'BatCH',
  },
  {
    name: 'South Africa',
    value: 'BatRSA',
  },
    {
    name: 'Kellanova',
    value: 'Kellanova',
  },
];

export const connectionTemplates = {
  BatCH: [
    {
      type: 'select',
      label: 'Type',
      formControlName: 'type',
      options: dataConnectionTypes,
      required: true,
    },
    {
      type: 'input',
      label: 'URL',
      formControlName: 'url',
      required: true,
    },
    {
      type: 'input',
      label: 'Auth path',
      formControlName: 'authpath',
      required: true,
    },
    {
      type: 'input',
      label: 'Consumer path',
      formControlName: 'consumerpath',
      required: true,
    },
    {
      type: 'input',
      label: 'Username',
      formControlName: 'username',
      required: true,
    },
    {
      type: 'input',
      label: 'Password',
      formControlName: 'password',
      inputType: 'password',
      required: true,
    },
  ],
  BatRSA: [
    {
      type: 'input',
      label: 'URL',
      formControlName: 'url',
      required: true,
    },
    {
      type: 'select',
      label: 'Signature Method',
      formControlName: 'signatureMethod',
      options: [
        {
          value: 'HMAC-SHA256',
          name: 'HMAC-SHA256',
        }
      ],
      required: true,
    },
    {
      type: 'input',
      label: 'Consumer Key',
      formControlName: 'consumerKey',
      required: true,
    },
    {
      type: 'input',
      label: 'Consumer Secret',
      formControlName: 'consumerSecret',
      inputType: 'password',
      required: true,
    },
    {
      type: 'input',
      label: 'Access Token',
      formControlName: 'accessToken',
      required: true,
    },
    {
      type: 'input',
      label: 'Token Secret',
      formControlName: 'tokenSecret',
      inputType: 'password',
      required: true,
    },
  ],
  Kellanova: [
    {
      type: 'input',
      label: 'URL Host',
      formControlName: 'url',
      required: true,
    },
    {
      type: 'input',
      label: 'Scope',
      formControlName: 'scope',
      required: true,
    },
    {
      type: 'input',
      label: 'Client Id',
      formControlName: 'clientId',
      required: true,
    },
    {
      type: 'input',
      label: 'Client Secret',
      formControlName: 'clientSecret',
      inputType: 'password',
      required: true,
    },
  ],
};
